import { render, staticRenderFns } from "./ChooseAgreement.vue?vue&type=template&id=8c9bd584&"
import script from "./ChooseAgreement.vue?vue&type=script&lang=js&"
export * from "./ChooseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAgreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports